import cx from '@utils/cx.util';
import Element from './Element';

type ContainerProps = {
  attributes: {
    title?: string;
    cssClass?: string;
    titleAlign?: 'left' | 'center' | 'right';
    titleStyle?: string;
  };
  children: any;
};

const Container = ({ attributes, children }: ContainerProps) => {
  const { title, cssClass, titleAlign, titleStyle } = attributes;

  const isHero = titleStyle === 'hero' || titleStyle === 'hero-alt';

  console.log('Container', { attributes })
  return (
    <div className={cx({
      'tw-bg-neutrals-eggshell': titleStyle === 'hero-alt',
    })}>
    <div className={cx('tw-mx-auto tw-my-6 tw-max-w-[1484px] tw-px-6 lg:tw-my-10', cssClass, {
      'tw-px-5 tw-py-12 tw-my-0 lg:tw-my-0': isHero,
    })}>
      {title && (
        <h3
          className={cx('tw-mb-5 tw-font-title tw-text-2xl tw-font-bold', {
            'tw-text-center': titleAlign === 'center',
            'tw-text-left': titleAlign === 'left',
            'tw-text-right': titleAlign === 'right',

            'tw-font-screamer tw-text-[40px] tw-uppercase tw-leading-none tw-text-black lg:tw-mb-14 lg:tw-text-center lg:tw-text-[80px]': isHero,
          })}>
          {title}
        </h3>
      )}
      <div className={cx('tw-flex tw-flex-col', {
        'tw-gap-12': isHero,
      })}>
      {children.map((c, i) => (
        <Element key={i} {...c} />
      ))}
      </div>
    </div>
    </div>
  );
};

export default Container;
